import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetDossierStatusIndicatorsController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierStatusIndicatorsController.php
* @route '/api/dossier/{dossier}/status-summary'
*/
const GetDossierStatusIndicatorsController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierStatusIndicatorsController.url(args, options),
    method: 'get',
})

GetDossierStatusIndicatorsController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/status-summary',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetDossierStatusIndicatorsController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierStatusIndicatorsController.php
* @route '/api/dossier/{dossier}/status-summary'
*/
GetDossierStatusIndicatorsController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetDossierStatusIndicatorsController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetDossierStatusIndicatorsController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierStatusIndicatorsController.php
* @route '/api/dossier/{dossier}/status-summary'
*/
GetDossierStatusIndicatorsController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierStatusIndicatorsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetDossierStatusIndicatorsController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierStatusIndicatorsController.php
* @route '/api/dossier/{dossier}/status-summary'
*/
GetDossierStatusIndicatorsController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierStatusIndicatorsController.url(args, options),
    method: 'head',
})

export default GetDossierStatusIndicatorsController